import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, race } from 'rxjs';
import { defaultIfEmpty, map, switchMap, take } from 'rxjs/operators';
import { currentEncounterId, isEmptyEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { makeDefaultAsyncActionEffect } from '@mona/store';
import { AnamnesisState } from '../../entities';
import { AnamnesesApi } from '../../infrastructure';
import { AnamnesisAction } from '../actions';

/**
 * Anamnesis effects
 */
@Injectable()
export class AnamnesisEffects {
    /* Effect Declarations */

    /**
     * Load anamnesis effect
     */

    loadAnamnesis$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AnamnesisAction.loadAnamnesisAction.action),
            switchMap(action =>
                race(
                    isEmptyEncounterId(this.store).pipe(
                        take(1),
                        map(() => AnamnesisAction.loadAnamnesisAction.clearAction()),
                    ),
                    from(
                        makeDefaultAsyncActionEffect(
                            this.anamnesesApi
                                .getAnamneses(action.encounterId)
                                .pipe(isSameEncounterFilter(currentEncounterId(this.store), action.encounterId)),
                            AnamnesisAction.loadAnamnesisAction,
                        ),
                    ).pipe(defaultIfEmpty(AnamnesisAction.loadAnamnesisAction.clearAction())),
                ),
            ),
        ),
    );

    /**
     * Constructor
     * @param actions$ Actions
     * @param anamnesesApi AnamnesesApi
     * @param store
     */
    constructor(
        private actions$: Actions,
        private anamnesesApi: AnamnesesApi,
        private store: Store<AnamnesisState>,
    ) {}
}
